import React from 'react';
import styled from 'styled-components';
import Colors from '../../styles/colors';

const PoweredBySoundwise = props => {
  return (
    <PoweredBy>
      <div className="notice">
        <i className="ti-lock" />
        Transactions are secure and encrypted.
      </div>
      <div className="logo sm-margin-three-top">
        <div className="powered-text text-small2">Powered by</div>
        <img src="../../images/soundwiselogo.svg" alt="image" />
      </div>
    </PoweredBy>
  );
};

const PoweredBy = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 991px) {
    flex-direction: column;
    align-items: flex-end;
  }

  .notice {
    display: flex;
    letter-spacing: 0.01em;
    font-size: 13px;
    color: #000;

    i {
      font-size: 16px;
      padding: 2px 5px 2px 0;
    }
  }

  .logo {
    display: flex;
    align-items: center;
    height: 27px;

    .powered-text {
      margin-right: 5px;
      font-weight: 600;
      display: inline-block;
    }

    img {
      display: block;
      height: 100%;
    }
  }
`;

export default PoweredBySoundwise;
